import React, { useRef, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { motion } from "framer-motion";
import { BONOS } from "../data/tomos";
const BONUS_PREVIEWS = ["https://cdn.magicpatterns.com/uploads/mEFQVkzgwZUessSWovTSSp/Bono_1_.png", "https://cdn.magicpatterns.com/uploads/3rQsViUyQc3uQut8MBHvez/Bono_2.png", "https://cdn.magicpatterns.com/uploads/tHs3frAdj1RS6E5Xbosbng/Bono_3.png", "https://cdn.magicpatterns.com/uploads/69Mf153Rdn4JseeQ4BNoVr/Bono_4_.png", "https://cdn.magicpatterns.com/uploads/5JQdtkYek68AinXbQz6gDN/Bono_5.png", "https://cdn.magicpatterns.com/uploads/fXynifyWBda2SAiT1FPaya/Screenshot_2026-07-17_at_9.59.24_PM.png"];
export function BonusCarousel() {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const move = (direction: "previous" | "next") => {
    const nextIndex = direction === "next" ? Math.min(activeIndex + 1, BONOS.length - 1) : Math.max(activeIndex - 1, 0);
    const card = carouselRef.current?.children[nextIndex] as HTMLElement | undefined;
    card?.scrollIntoView({
      behavior: "smooth",
      inline: "start",
      block: "nearest"
    });
    setActiveIndex(nextIndex);
  };
  return <div className="mt-6" data-id="element-29" data-mp="36gkrd92i04l2">
      <div className="mb-3 flex items-center justify-between" data-id="element-30" data-mp="31h88ezeqzhnr">
        <p className="text-xs font-semibold uppercase tracking-[0.12em] text-italian-green/70" data-id="element-31" data-mp="31j1f2epd21vr">
          Deslizá para ver los 6 bonos
        </p>
        <div className="flex gap-2" data-id="element-32" data-mp="3u65fe6dids17">
          <button type="button" onClick={() => move("previous")} disabled={activeIndex === 0} aria-label="Ver bono anterior" className="grid h-8 w-8 place-items-center rounded-full border border-sand bg-cream text-italian-green disabled:cursor-not-allowed disabled:opacity-35" data-id="element-33" data-mp="3u76zf0ci5ov2">
            <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-34" data-mp="28sj4ytq7z08u" />
          </button>
          <button type="button" onClick={() => move("next")} disabled={activeIndex === BONOS.length - 1} aria-label="Ver siguiente bono" className="grid h-8 w-8 place-items-center rounded-full border border-sand bg-cream text-italian-green disabled:cursor-not-allowed disabled:opacity-35" data-id="element-35" data-mp="28uvsdmeqy2ta">
            <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-36" data-mp="vsfuu27c9d89" />
          </button>
        </div>
      </div>

      <div ref={carouselRef} onScroll={event => {
      const container = event.currentTarget;
      const next = Math.round(container.scrollLeft / container.clientWidth);
      setActiveIndex(Math.min(Math.max(next, 0), BONOS.length - 1));
    }} className="-mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Carrusel de bonos incluidos" data-id="element-37" data-mp="h3ti8893izkq">
        {BONOS.map((bonus, index) => <motion.article key={bonus.title} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.35
      }} className="w-[84%] shrink-0 snap-start overflow-hidden rounded-3xl border border-gold/35 bg-cream shadow-md" data-id="element-38" data-mp="3766gzchi4ur" data-mpi={index}>
            <img src={BONUS_PREVIEWS[index]} alt={`Vista previa del ${bonus.title}`} className="aspect-[4/3] w-full border-b border-sand object-cover object-top" data-id="element-39" data-mp="3kmpkgovdxen7" />
            <div className="p-4" data-id="element-40" data-mp="3ukdsuhlwyknu">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-gold/15 text-base" aria-hidden="true" data-id="element-41" data-mp="c8qpnqk5fzba">
                {bonus.emoji}
              </span>
              <h3 className="mt-3 text-sm font-bold leading-snug text-italian-green" data-id="element-42" data-mp="m656vsdwcs4n">
                {bonus.title}
              </h3>
              <p className="mt-2 text-[13px] leading-relaxed text-ink/75" data-id="element-43" data-mp="h8d7kdaxa3qf">
                {bonus.content}
              </p>
            </div>
          </motion.article>)}
      </div>

      <div className="mt-1 flex justify-center gap-1.5" aria-hidden="true" data-id="element-44" data-mp="2fo2g5amo81k3">
        {BONOS.map((bonus, index) => <span key={bonus.title} className={`h-1.5 rounded-full transition-all ${index === activeIndex ? "w-5 bg-gold" : "w-1.5 bg-sand"}`} data-id="element-45" data-mp="2kh5f5ya7w37o" data-mpi={index} />)}
      </div>
    </div>;
}